const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

export default GA_TRACKING_ID;
